import { render, staticRenderFns } from "./icon-arrow-rounded.vue?vue&type=template&id=7974861f&scoped=true&"
import script from "./icon-arrow-rounded.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-rounded.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow-rounded.vue?vue&type=style&index=0&id=7974861f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7974861f",
  null
  
)

export default component.exports